import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import styles from './styles';
import LumenLoader from 'components/Loader';
import { withStyles } from '@mui/styles';
import { useAuth0 } from '@auth0/auth0-react';
import { Redirect } from 'react-router-dom';

interface LoadingProps {
    classes: any;
}

const Loading: React.FunctionComponent<LoadingProps> = ({ classes }) => {
    const {
        isAuthenticated: auth0isAuthenticated,
        getAccessTokenSilently,
        user: auth0User,
        isLoading: auth0isLoading,
        error,
    } = useAuth0();

    if (error) {
        const tmp = error as any; // this is required because Auth0 error type is not correct with actual error object
        if (tmp.error === 'access_denied') {
            return <Redirect to={'/forbidden'} />;
        } else {
            return <Redirect to={'/logout'} />;
        }
    }

    return (
        <Grid className={classes.root} container alignContent="center" alignItems="center" justifyContent="center">
            <Grid className={classes.content}>
                <LumenLoader />
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(Loading);
